import React, {useState} from "react";
import Login from "./login";
import ForgotPassword from "./forgotPassword";

const LoginPage = () => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  if (showForgotPassword) {
    return <ForgotPassword setShowForgotPassword={setShowForgotPassword} />;
  } else {
    return <Login setShowForgotPassword={setShowForgotPassword} />;
  }
};

export default LoginPage;
